(function () {
  "use strict";

  // Track scroll handlers per section so we can clean them up on section reload/unload
  var scrollHandlers = new Map();

  function initSection(section) {
    if (!section || section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    var sectionId = section.id;
    var bar = section.querySelector("[data-floating-bar]");
    var menuOpenBtn = section.querySelector("[data-menu-open]");
    var menuCloseBtn = section.querySelector("[data-menu-close]");
    var menuOverlay = section.querySelector("[data-menu-overlay]");
    var menuDrawer = section.querySelector("[data-menu-drawer]");

    // === Smart Scroll: hide on scroll-down, show on scroll-up ===
    if (bar) {
      // Clean up old listener if section is being re-initialized
      if (scrollHandlers.has(sectionId)) {
        window.removeEventListener("scroll", scrollHandlers.get(sectionId));
        scrollHandlers.delete(sectionId);
      }

      var lastScroll = 0;
      var scrollHandler = function () {
        var currentScroll = window.pageYOffset;

        if (currentScroll <= 0) {
          section.classList.remove("cwc_floating-header--bar-hidden");
          lastScroll = 0;
          return;
        }

        if (currentScroll > lastScroll && currentScroll > 100) {
          section.classList.add("cwc_floating-header--bar-hidden");
        } else {
          section.classList.remove("cwc_floating-header--bar-hidden");
        }

        lastScroll = currentScroll;
      };

      scrollHandlers.set(sectionId, scrollHandler);
      window.addEventListener("scroll", scrollHandler, { passive: true });
    }

    // === Menu Drawer ===
    if (menuOverlay && menuDrawer) {
      var drawerToggles = menuDrawer.querySelectorAll("[data-drawer-toggle]");

      function resetDrawerAccordion() {
        drawerToggles.forEach(function (toggle) {
          toggle.setAttribute("aria-expanded", "false");
          var targetId = toggle.getAttribute("aria-controls");
          var target = targetId ? document.getElementById(targetId) : null;
          if (target) {
            target.classList.remove(
              "cwc_floating-header__menu-drawer-sublist--expanded",
            );
          }
        });
      }

      function openMenu() {
        menuDrawer.classList.add("cwc_floating-header__menu-drawer--open");
        menuOverlay.classList.add("cwc_floating-header__menu-overlay--visible");
        menuDrawer.setAttribute("aria-hidden", "false");
        if (menuOpenBtn) menuOpenBtn.setAttribute("aria-expanded", "true");
      }

      function closeMenu() {
        menuDrawer.classList.remove("cwc_floating-header__menu-drawer--open");
        menuOverlay.classList.remove(
          "cwc_floating-header__menu-overlay--visible",
        );
        menuDrawer.setAttribute("aria-hidden", "true");
        if (menuOpenBtn) menuOpenBtn.setAttribute("aria-expanded", "false");
        resetDrawerAccordion();
      }

      if (menuOpenBtn) menuOpenBtn.addEventListener("click", openMenu);
      if (menuCloseBtn) menuCloseBtn.addEventListener("click", closeMenu);
      menuOverlay.addEventListener("click", closeMenu);

      // Drawer accordion: expand/collapse sub-links
      drawerToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          var expanded = toggle.getAttribute("aria-expanded") === "true";
          var targetId = toggle.getAttribute("aria-controls");
          var target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;

          if (expanded) {
            toggle.setAttribute("aria-expanded", "false");
            target.classList.remove(
              "cwc_floating-header__menu-drawer-sublist--expanded",
            );
          } else {
            toggle.setAttribute("aria-expanded", "true");
            target.classList.add(
              "cwc_floating-header__menu-drawer-sublist--expanded",
            );
          }
        });
      });

      // Close drawer on Escape
      document.addEventListener("keydown", function (e) {
        if (
          e.key === "Escape" &&
          menuDrawer.classList.contains(
            "cwc_floating-header__menu-drawer--open",
          )
        ) {
          closeMenu();
          if (menuOpenBtn) menuOpenBtn.focus();
        }
      });
    }
  }

  function cleanupSection(section) {
    if (!section) return;
    var sectionId = section.id;
    if (scrollHandlers.has(sectionId)) {
      window.removeEventListener("scroll", scrollHandlers.get(sectionId));
      scrollHandlers.delete(sectionId);
    }
  }

  function initAll() {
    document.querySelectorAll(".cwc_floating-header").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // === Theme Editor support ===
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".cwc_floating-header");
    if (section) initSection(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector(".cwc_floating-header");
    if (section) cleanupSection(section);
  });
})();
